import React from 'react'
import { useAbundanceEngineBranding } from '../../../../../api/abundanceEngine'
import EmptySection from '../../../../atoms/EmptySection'
import SydButton from '../../../../commonDesign/Button'
import OperationalTable from '../../../../organisms/OperationalTable'
import Loading from '../../../../molecules/Loading'
import { useCheckPolicy } from '../../../../../hooks'
import { PERMISSIONS } from '../../../../../policies/admin'
import { useFeatureFlag } from '../../../../../redux/slices/appConfig'
import { FEATURE_FLAG } from '../../../../../constants'
import BrandModal from './BrandModal'

const Brands = () => {
  const { active: canViewBrands } = useFeatureFlag(FEATURE_FLAG.MULTI_BRAND_FIRM)
  const canAddBrands = useCheckPolicy(PERMISSIONS.brandConfiguration)
  const defaultColumnConfig = {
    columns: [
      { Header: 'Brand Name', accessor: 'brandKey', type: 'string' },
      { Header: 'Wealth Mission', accessor: 'tagLine', type: 'string' },
      { Header: 'Firm Logo', accessor: 'logoUrl', type: 'string' },
      { Header: 'Firm Icon', accessor: 'data.icons.favicon', type: 'string' }
    ],
    defaultSort: [{ id: 'ordinal', desc: false }]
  }
  const { data: brands, isLoading, error } = useAbundanceEngineBranding()
  const [brandAddOpen, setBrandAddOpen] = React.useState(false)
  const onAddClick = () => {
    setBrandAddOpen(true)
  }
  if (!canViewBrands) {
    return (
      <EmptySection
        title='Access Denied'
        description='You do not have sufficient permissions to access this resource'
      />
    )
  }

  if (isLoading) {
    return <Loading />
  }

  if (error) {
    return <div>Error loading brands: {error.message}</div>
  }

  return (
    <>
      <BrandModal open={brandAddOpen} onClose={() => setBrandAddOpen(false)} />
      <div>
        <OperationalTable.Wrapper>
          {canAddBrands && (
            <div className='flex flex-row justify-end mb-4'>
              <SydButton size='md' variant='primary' icon='add' onClick={() => onAddClick(true)}>Add Branding</SydButton>
            </div>
          )}
          <OperationalTable
            variant='v2'
            mode='auto'
            itemName='Branding'
            columns={defaultColumnConfig.columns}
            defaultSort={defaultColumnConfig.defaultSort}
            data={brands}
            total={brands.length}
          />
        </OperationalTable.Wrapper>
      </div>
    </>
  )
}

export default Brands
